const ROUTES = {
    DEFAULT: '/',
    DRUG_FORM: '/drug-report-form',
    COMMUNITY: '/community',
    COMMUNITY_FORM: '/community/form',
    CHAT: '/chat',
    ARTICLE: '/article/:id',
    INTERNAL: {
        VISUALIZE: '/visualize',
    },
};

export default ROUTES;
